/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react'
import { AuthProvider } from './src/contexts/AuthContext'
import CookieBanner from './src/components/CookieConsent'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>
}

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <CookieBanner />
    </>
  )
}
